<template>
  <div class="weather-cmp bg-center">
    <div class="left-bg-title bg-center pd10tb">气象数据</div>
    <div class="weather-content">
      <p class="weather-data">{{ getDate }}</p>
		<template v-if="weatherData3.length > 0">
			<div class="weather-box">
				<template v-for="(item,index) in weatherData3">
					<!-- <div class="left"> -->
					  <p>{{item.name}}:{{item.value}}{{item.unit}}</p>
					<!-- </div>
					<div class="right">
					  <p v-if="index > 4">{{item.name}}:{{item.value}}{{item.unit}}</p>
					</div> -->
				</template>
			</div>
		</template>
		<template v-else>
			<div class="weather-info">
				<div class="left">
				  <p>风级：{{weatherData2.windDir+weatherData2.windLevel+"级"}}</p>
				  <p>PM10：{{weatherData.pm10}}ug/m3</p>
				  <p>一氧化碳指数：{{weatherData.co}}</p>
				  <p>臭氧浓度：{{weatherData.o3C}}</p>
				  <p>二氧化氮指数：{{weatherData.no2}}</p>
				</div>
				<div class="right">
				  <p>空气温度：{{weatherData2.temp}}℃</p>
				  <p>PM2.5：{{weatherData.pm25}}ug/m3</p>
				  <p>一氧化碳浓度：{{weatherData.coC}}</p>
				  <p>空气湿度：{{weatherData2.humidity}}%RH</p>
				  <p>二氧化氮指数：{{weatherData.no2C}}</p>
				</div>
			</div>
		</template>
      
    </div>
  </div>
</template>

<script>
import {
	getCommpany,
	getLatAndLngByAddress,
	briefcondition,
	weather,
	briefforecast6days,
	meteorologicalData
	} from "@/api/region.js";
	import {mapGetters} from "vuex";
export default {
  data() {
    return {
      year: null, // 气象数据版面初始化数据中的年,
      month: null, // 气象数据版面初始化数据中的月,
      day: null, // 气象数据版面初始化数据中的日,
      hour: null, // 气象数据版面初始化数据中的小时,
      min: null, // 气象数据版面初始化数据中的分钟,
      sec: null, // 气象数据版面初始化数据中的秒钟,
      week: null, // 气象数据版面初始化数据中的周,
      weatherData: {},
      weatherData2: {},
	  videolist:[],
	  weatherData3:[],
    };
  },  
  watch: {
    // $route(to, from) {
    //   if (/\/company/gi.test(to.path)) {

    //   }
    // }
	async orgIdNum(val)
	{
		if(val != 0)
		{
			this.getTime();
			this.getInfo();
		}
	},
	videoList(val) {
		let result = '';
		val.forEach((item,index) => {
			if(index == val.length-1)
			{
				result += 'deviceIds=' + item.deviceId
			}
			else
			{
				result += 'deviceIds=' + item.deviceId + '&'
			}
		})
		console.log("result",result)
		meteorologicalData(result)
		.then(res => {
			console.log("====meteorologicalData===",res)
			this.weatherData3 = res.data;
		})
	}
  },
  mounted() {
     this.getTime();
    this.getInfo();
  },
  
  computed: {
	  ...mapGetters(['orgIdNum','videoList']),
    // 计算属性保证实时更新数据
    getDate() {
      return `实时监测数据:${this.year}年${this.month}月${this.day}日 ${this.hour}:${this.min}:${this.sec} 星期${this.week}`;
    }
  },
  methods: {
     getInfo() {
      //要返回出去的请求回来的对象
      let id= this.orgIdNum;
	  console.log(id)
		getCommpany(id)
        .then(res => {
			console.log("getInfo",res)
             let address = res.data.districtName;
            this.address=address;
            this.getjw(address);
        })
        .catch(err => {
          console.log(err);
        });
    },

    getjw(address) {
      getLatAndLngByAddress(address)
        .then(res => {
			console.log("getjw",res)
        //  if (res.status == 200) {
            let point = {
              lat: res.data.lat,
              lng: res.data.lng
            };
            this.getData(point);
          // }
        })
        .catch(err => {});
    },
    getData(point) {
      let d = {
        lat: point.lat,
        lon: point.lng
      };
      briefcondition(d)
        .then(res => {
			console.log('briefcondition',res)
          if (res.code == 0) {
			  
            this.weatherData2 = res.data.data.condition;
          }
        })
        .catch(err => {});

      weather(d)
        .then(res => {
          if (res.code == 0) {
            this.weatherData = res.data.data.aqi;
          }
        })
        .catch(err => {});

      briefforecast6days(d)
        .then(res => {
          if (res.code == 0) {
            this.forecast = res.data.data.forecast;
          }
        })
        .catch(err => {});
    },
    // 每隔一秒钟要执行的更新时间函数,
    getTime() {
      this.setTime();
      let timer = setInterval(() => {
        this.setTime();
      }, 1000);
    },
    // 初始化data时间,
    setTime() {
      let date = new Date();
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1;
      this.day = date.getDate();
      this.hour = date.getHours();
      this.min = date.getMinutes();
      this.sec = date.getSeconds();
      this.week = this.changeWeekNumToText(date.getDay());
    },
    //把周末的数字转化为汉字,
    changeWeekNumToText(config) {
      let weekArr = ["日", "一", "二", "三", "四", "五", "六"];
      return weekArr[config];
    }
  }
};
</script>

<style lang='less'>
//组件总体样式,
.weather-cmp {
  padding-top: 15px;
  padding-left: 10px;
  box-sizing: border-box;
  position: relative;
  height: 235px;
  max-width: 540px;
  min-width: 400px;
  min-height: 200px;
  width: 100%;
  background-image: url(../../assets/images/right-div-ch.png);
  background-size: 100% 100%;
  margin-bottom: 20px;
  //内部主体
  .weather-content {
    .weather-data {
      width: 100%;
      text-align: center;
      height: 22px;
      line-height: 22px;
      font-weight: bold;
    }
    .weather-info {
      margin-top: 15px;
      display: flex;
      justify-content: space-around;
      p {
        height: 30px;
        line-height: 30px;
      }
    }
	.weather-box{
		margin: 10px 0px;
		overflow: hidden;
		p {
		  height: 30px;
		  line-height: 30px;
		  float: left;
		  width: 40%;
		  padding-left: 10%;
		}	
	}
  }
}
</style>